<script setup>
import ModuleContentCard from '@/components/cards/moduleContentCard/ModuleContentCard.vue';
import SectionDivider from './SectionDivider.vue';
import { isItemNow } from '@/utils/helpers';
import { isToday } from 'date-fns';

defineProps({
  shouldShowInfoTag: {
    type: Boolean,
    default: true,
  },
  filter: {
    required: false,
    type: String,
  },
  shouldShowSectionDivider: {
    type: Boolean,
    default: true,
    required: false,
  },
  entryRouterName: {
    type: String,
    required: true,
  },
  routeName: {
    type: String,
    required: true,
  },
  backgroundColor: {
    type: String,
    required: true,
    default: 'red',
  },
  shouldShowDate: {
    type: Boolean,
    default: true,
  },
  shouldShowMediaCount: {
    type: Boolean,
    default: false,
  },
  sections: {
    required: true,
    type: [
      {
        sectionTitle: {
          type: String,
          required: true,
        },
        sectionContent: {
          required: true,
          type: [
            {
              imgSrc: {
                type: String,
                required: true,
              },
              title: {
                type: String,
                required: true,
              },
              startdate: {
                type: String,
                required: false,
              },
              endDate: {
                type: String,
                required: false,
              },
              cancelled: {
                type: Boolean,
                required: false,
                default: false,
              },
            },
          ],
        },
      },
    ],
  },
});

const emit = defineEmits(['entry-item-clicked']);
</script>

<template>
  <div>
    <div
      v-for="{ sectionTitle, sectionEntries } in sections"
      :key="sectionTitle"
      class="bg-neutral-100"
    >
      <SectionDivider
        v-if="shouldShowSectionDivider"
        :sectionTitle="sectionTitle"
        class="pb-8 pt-2"
      />
      <div
        v-for="item in sectionEntries"
        class="flex justify-center"
        :key="`content-card-${item.id}`"
      >
        <div data-pressable class="h-[478px] w-[680px] pb-6">
          <ModuleContentCard
            @click="emit('entry-item-clicked', item)"
            :backgroundColor="backgroundColor"
            :imgSrc="item.coverImage.source"
            :title="item.title"
            :date="item.startDate"
            :isToday="isToday(item.startDate, item.endDate)"
            :isNow="isItemNow(item.startDate, item.endDate)"
            :isCancelled="item.cancelled"
            :picturesCount="item.pictures?.length"
            :videosCount="item.videos?.length"
            :mediaCount="item.media?.length"
            :shouldShowMediaCount="shouldShowMediaCount"
            :shouldShowDate="shouldShowDate"
            :shouldShowInfoTag="shouldShowInfoTag"
            :item="item"
          />
        </div>
      </div>
    </div>
  </div>
</template>
